import { render } from "./VxPost.vue?vue&type=template&id=35fc0184&scoped=true"
import script from "./VxPost.vue?vue&type=script&lang=js"
export * from "./VxPost.vue?vue&type=script&lang=js"

import "./VxPost.vue?vue&type=style&index=0&id=35fc0184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fc0184"]])

export default __exports__